(() => {
  const root = document.querySelector('.ww-h2-pdp');
  if (!root) return;
  const form = root.querySelector('#ww-v2-pdp-form');
  const variants = root.querySelector('#ww-v2-variant-select');
  const frequency = root.querySelector('[data-h2-frequency]');
  const plans = JSON.parse(root.querySelector('[data-h2-plans]').textContent);
  const planInput = root.querySelector('[data-selling-plan-input]');
  const sticky = root.querySelector('[data-h2-sticky]');
  const atc = root.querySelector('[data-ww-atc]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents/100);
  const variantId = () => form.querySelector('[name="id"]').value;
  const subscription = () => form.querySelector('[name="ww_purchase_type"]:checked')?.value === 'subscription';
  function buildPlans() {
    if (!frequency) return;
    const oldName = frequency.selectedOptions[0]?.textContent;
    frequency.replaceChildren();
    (plans[variantId()] || []).forEach(plan => {
      const option = new Option(plan.name, String(plan.id));
      option.dataset.price = plan.price;
      if (plan.name === oldName) option.selected = true;
      frequency.add(option);
    });
  }
  function sync() {
    const selected = variants?.selectedOptions[0];
    const base = root.querySelector('[data-ww-current-variant]').dataset;
    const regular = Number(selected ? selected.dataset.priceCents : base.currentPriceCents);
    const plan = (plans[variantId()] || []).find(p => String(p.id) === frequency?.value);
    const isSub = subscription() && !!plan;
    const price = isSub ? plan.price : regular;
    if (frequency) {
      root.querySelector('[data-h2-frequency-wrap]').hidden = !subscription() || !frequency.options.length;
      frequency.disabled = !subscription();
      if (planInput) { planInput.value = plan ? String(plan.id) : ''; planInput.disabled = !isSub; }
      if (plan) {
        root.querySelector('[data-ww-subscription-price]').textContent = money(plan.price);
        root.querySelector('[data-h2-savings]').textContent = 'Save ' + money(regular - plan.price) + ' per order · ' + plan.name;
      }
    }
    root.querySelector('[data-ww-product-price]').textContent = money(price);
    const atcPrice = root.querySelector('[data-ww-atc-price]');
    if (atcPrice) atcPrice.textContent = money(price);
    const label = selected ? selected.textContent.replace(' - Sold Out','').trim() : root.querySelector('h1').textContent.trim();
    root.querySelector('[data-h2-sticky-label]').textContent = label + ' · ' + (isSub ? plan.name : 'One-time purchase') + ' · ' + money(price);
    root.querySelector('[data-h2-sticky-button]').disabled = atc.disabled;
    root.querySelector('[data-h2-sticky-button]').textContent = atc.disabled ? 'Sold out' : 'Add to cart';
    if (selected) {
      const url = new URL(location.href); url.searchParams.set('variant',selected.value); history.replaceState(null,'',url);
    }
  }
  document.addEventListener('change', event => {
    if (event.target === variants) buildPlans();
    if (event.target === variants || event.target === frequency || event.target.matches('[name="ww_purchase_type"]')) sync();
  });
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
    const e = entries[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.bottom > 0;
  }).observe(atc);
  buildPlans(); sync();
})();
